module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("71O8Z"))).then(() => parcelRequire('1iHdE'));